import { Alert, Badge, Code, Group, Stack } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons';
import type { PlaygroundErrorType } from '../../../api/types';
import type { DisplayablePlaygroundError } from '../../../api/integrations-playground-service';

const ERROR_COLORS: Record<PlaygroundErrorType, string> = {
  auth: 'red',
  rate_limit: 'orange',
  validation: 'yellow',
  not_found: 'gray',
  timeout: 'orange',
  unknown: 'red',
};

interface PlaygroundErrorDisplayProps {
  error: DisplayablePlaygroundError;
}

export function PlaygroundErrorDisplay({ error }: PlaygroundErrorDisplayProps) {
  const color = error.errorType ? ERROR_COLORS[error.errorType] : 'red';
  return (
    <Alert
      icon={<IconAlertTriangle size={16} />}
      color={color}
      variant="light"
      title={
        <Group spacing="xs">
          <span>Call failed</span>
          {error.errorType && (
            <Badge color={color} variant="filled" size="sm">
              {error.errorType}
            </Badge>
          )}
        </Group>
      }
    >
      <Stack spacing="xs">
        <Code block sx={{ fontSize: 12, whiteSpace: 'pre-wrap' }}>
          {error.message}
        </Code>
      </Stack>
    </Alert>
  );
}
